import React, { useEffect, useRef } from 'react'
import { InfoCDRLogo } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid'
import { BusinessPurpose } from './BusinessPurpose'

export const WelcomeB2BSolar = ({
  setUserConsented,
  userConsented,
  sendCode,
  errorMessage,
  email,
  handleChangeEmail,
  validateEmail
}) => {
  const { vendorData } = useApplicationContext()
  const ref = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
  }, [])

  return (
    <>
      <div ref={ref} className='cq-w-sm:w-3/5 flex-auto cq-w-sm:mr-8'>
        <p data-testid='welcome-paragraph1'>
          <span className='text-base sm:text-lg'>
            {vendorData.config.name} wants to help you get your energy data! To do this you can use Verifier’s Energy
            View.
          </span>
        </p>
        <p data-testid='welcome-paragraph2'>
          <span className='text-base sm:text-lg'>
            It’s a simple way for you to get your electricity billing and usage data for the past 12 months.
          </span>
        </p>
        <p data-testid='welcome-paragraph3'>
          <span className='text-base sm:text-lg'>
            To provide you with Energy View, Verifier uses the Consumer Data Right (CDR) and asks for your consent at
            every step along the way.{' '}
            <a
              href='https://www.cdr.gov.au/'
              target='_blank'
              rel='noreferrer'
              data-testid='link-cdr-more'
              id='introduction-cdrMore-link'
            >
              More about the CDR.
            </a>{' '}
            <ArrowTopRightOnSquareIcon className='w-4 h-4 text-infoCdrColor inline flex-none' />
          </span>
        </p>

        <p data-testid='welcome-paragraph4'>
          <span className='text-base sm:text-lg'>
            We will take you through the steps required for you to authorise us:
          </span>
        </p>

        <ul className='list-disc ml-9' data-testid='steps-required-to-authorise-list'>
          <li>
            <span className='text-base sm:text-lg'>to collect your data from your electricity retailer,</span>
          </li>
          <li>
            <span className='text-base sm:text-lg'>
              to disclose your data to Green Data Exchange Pty Ltd, which will enable {vendorData.config.name} to use
              your energy data to provide you a solar assessment.
            </span>
          </li>
        </ul>

        <p data-testid='what-green-data-exchange-will-do'>
          <span className='text-base sm:text-lg'>
            Green Data Exchange will securely store your account details and data. You can ask Green Data Exchange to
            give you a copy of your data at any time by emailing your request to{' '}
            <a href='mailto:energyview@greendataexchange.me' target='_blank' rel='noreferrer'>
              energyview@greendataexchange.me
            </a>
          </span>
        </p>

        <BusinessPurpose
          userConsented={userConsented}
          setUserConsented={setUserConsented}
          email={email}
          handleChangeEmail={handleChangeEmail}
          validateEmail={validateEmail}
          sendCode={sendCode}
          errorMessage={errorMessage}
        />

        <InfoCDRLogo
          accreditationLink={process.env.ACCREDITATION_LINK}
          accreditationNumber={process.env.ACCREDITATION_NUMBER}
          companyName={process.env.COMPANY}
        />
      </div>
    </>
  )
}
